<template>
  <div class="myOrderBox">
    <!-- 标题box -->
    <div class="myOrderBox_title">
      {{ title
      }}<el-select v-model="subPeopleId" placeholder="请选择" style="margin-left: 50px" @change="changeAccount">
        <el-option :label="parentName" :value="JSON.parse($cookies.get('peopleId'))">
        </el-option>
        <el-option label="全部" value=""> </el-option>
        <el-option v-for="item in subAccountList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <span class="serviceBox"><img src="/static/image/serviceTel.png" alt="" /><span>售后请联系区域客服经理</span></span>
    </div>
    <!-- 主体box -->
    <div class="myOrderBox_main">
      <!-- 顶部导航栏 -->
      <div class="mainBox_nav">
        <div class="mainBox_navL">
          <div :class="['mainBox_navList', index == chooseIndex ? 'active' : '']" v-for="(item, index) in navList" :key="index" @click="changeNav(index)">
            {{ item }}
          </div>
        </div>
        <div class="mainBox_navBtn" @click="changeMerge(true)" v-if="orderList.length > 0&&chooseIndex!=4&&chooseIndex!=5">
          <img src="/static/image/invoice.svg" alt="" class="mainBox_navBtnImg" />
          <span>合并开票</span>
        </div>
        <!-- <div class="mainBox_navR">
          <input
            class="mainBox_navIpt"
            type="text"
            placeholder="订单编号/商品名称"
          />
          <img
            src="../../../../static/image/search.svg"
            alt=""
            class="searchIcon"
          />
        </div> -->
      </div>
      <!-- 表头 -->
      <div class="mainBox_titleBox">
        <div style="width: 430px">订单详情</div>
        <div style="width: 160px">订单状态</div>
        <div style="width: 160px">支付状态</div>
        <div style="width: 180px">订单金额</div>
        <div style="width: 144px">操作</div>
      </div>
      <!-- 无数据替代 -->
      <el-empty description="暂无数据" v-if="orderList.length == 0"></el-empty>
      <!-- 订单列表 -->
      <div class="mainBox_orderBox" :style="mergeInvoice ? 'max-height: 600px' : ''">
        <div class="mainBox_orderList" v-for="(item, index) in orderList" :key="index" :style="{ 'margin-top': mergeInvoice ? '13px' : '20px' }">
          <div class="orderList_top">
            <img :src="
                '/static/image/' +
                  (item.chooseStatus == 1 ? 'choosed' : 'unChoosed') +
                  '.png'
              " alt="" v-if="mergeInvoice && item.chooseStatus != 2" class="chooseImg" :style="item.chooseStatus == 2 ? 'cursor:not-allowed' : ''" @click="
                item.chooseStatus == 2
                  ? ''
                  : changeChoose(index, item.chooseStatus)
              " />
            <span>{{ getDate(item.createTime) }}</span><span>订单编号：{{ item.ordersn }}</span>
          </div>
          <div class="orderList_main" :style="{ height: mergeInvoice ? '47px' : '117px' }">
            <img :src="item.goodsList[0] ? item.goodsList[0].goodsThumb : ''" alt="" class="orderList_img" @click="
                gotoDetails(item.goodsList[0] ? item.goodsList[0].goodsId : '')
              " v-if="!mergeInvoice" />
            <div :style="{
                width: mergeInvoice ? '330px' : '157px',
                'text-align': 'left',
                cursor: 'pointer'
              }" @click="
                gotoDetails(item.goodsList[0] ? item.goodsList[0].goodsId : '')
              ">
              {{ item.goodsList[0] ? item.goodsList[0].title : "" }}
            </div>
            <span style="width: 100px" class="mainSpan">共{{ item.goodsList.length }}种</span>
            <div style="width: 160px; text-align: center">
              {{ item.statusExplain }}
            </div>
            <div style="width: 160px">{{item.payStatusExplain}}</div>
            <div class="orderPrice_text">
              <span style="color: #ff4019; font-size: 16px">￥<span style="font-size: 21px">{{
                  item.price.toFixed(2)
                }}</span></span>
              <!-- <span>在线支付</span> -->
            </div>
            <div class="btnBox" @click.stop="nothing()" :style="mergeInvoice ? 'padding:8px 0' : ''">
              <el-link :underline="false" type="primary" style="font-size: 12px; height: 16px" @click.stop="gotoDetails2(item.id, item.peopleId)" v-if="!mergeInvoice">订单详情</el-link>
              <!-- <el-link
              v-if="item.status == 3"
              :underline="false"
              type="primary"
              style=" font-size: 12px;margin-left:15px;height:16px"
              >申请售后</el-link
            > -->

              <el-button v-if="item.status == 1 || item.status == 2" type="primary" @click="finishOrder(item.id, item.peopleId)" style="font-size: 14px; width: 80px; height: 30px; padding: 0">确认收货</el-button>
              <el-upload v-if="!item.verifycode && !mergeInvoice && item.status != -1" slot="description" class="upload-demo" :action="baseURL + (item.verifycode ? editUrl : uploadUrl)" :data="{
                  token: token,
                  orderId: item.id
                }" accept=".jpg,.gif,.png,.pdf" :on-success="uploadSuccess" :limit="1" :file-list="fileList" :show-file-list="false">
                <el-link :underline="false" type="primary" style="font-size: 12px">{{ item.verifycode ? "修改" : "上传" }}付款凭证</el-link>
              </el-upload>
               <!-- :disabled="item.isInvoiced==1" -->
              <el-link v-if="!mergeInvoice && item.status != -1" :underline="false" type="primary" @click="
                  item.isInvoiced == 0
                    ? item.status == 3
                      ? item.price > 100000
                        ? exceedShow(item.id, item.peopleId)
                        : showDialog(item.id, item.peopleId)
                      : (isNotReceived = true)
                    : gotoInvoiceDetails(item.invoiceId)
                " style="font-size: 12px; height: 16px">{{item.isInvoiced==0?"申请发票":item.isInvoiced==1? "已开具发票":""}}</el-link>
              <el-link v-if="item.status == 3" :underline="false" type="primary" style="font-size: 12px; height: 16px" @click.stop="gotoRate(item.ordersn,item.createTime)">{{item.isRate==0?'立即评价':'评价详情'}}</el-link>
              <!-- <el-link v-if="item.status >= 1 && item.signStatus === 0" :underline="false" type="primary" style="font-size: 12px; height: 16px" @click.stop="applyContract(item)">申请合同</el-link> -->
            </div>
          </div>
          <!-- <div class="orderList_rateBtnBox" v-if="item.status == 3">
            <el-link :underline="false" type="primary" style="font-size: 12px; height: 16px" @click.stop="gotoRate(item.ordersn,item.createTime)">{{item.isRate==0?'立即评价':'已评价'}}</el-link>
          </div> -->
        </div>
      </div>
      <!-- 底部分页 -->
      <div class="pagination" v-if="!mergeInvoice">
        <el-pagination background @current-change="handleCurrentChange" :current-page="current" layout=" prev, pager, next,total, jumper" :total="total" :page-size="limit">
        </el-pagination>
      </div>
      <!-- 开票合计 -->
      <div class="totalBox" v-if="mergeInvoice">
        <div class="selectAllBox" @click="selectAll()">
          <img :src="
              '/static/image/' +
                (isSelectAll ? 'choosed' : 'unChoosed') +
                '.png'
            " alt="" class="chooseImg" v-if="
              mergeInvoice &&
                orderList.some(item => {
                  return item.chooseStatus == 0 || item.chooseStatus == 1;
                })
            " /><span v-if="
              mergeInvoice &&
                orderList.some(item => {
                  return item.chooseStatus == 0 || item.chooseStatus == 1;
                })
            ">全选</span>
        </div>
        <div class="totalBox_r">
          <div class="totalBox_top">
            <span>订单数：{{ totalInvoice }}件</span>
            <span>合计：</span>
            <span>¥{{ totalPrice.toFixed(2) }}</span>
          </div>
          <div class="totalBox_btnBox">
            <div class="totalBox_btn" @click="changeMerge()">取消合并开票</div>
            <div class="totalBox_btn totalBox_btnConfirm" @click="submitMergeInvoice()">
              确认合并开票
            </div>
          </div>
        </div>
      </div>
    </div>
    ⁣⁣⁣⁣
    <!-- 申请开票弹窗 -->
    <el-dialog :title="isShowQrCode ? '⁣⁣⁣⁣　' : '申请开票'" :visible.sync="dialogVisible" width="767px" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="121px" class="demo-ruleForm" v-show="!isShowQrCode">
        <el-form-item label="抬头类型：" prop="headType" style="margin-bottom: 20px">
          <el-radio-group v-model="ruleForm.headType" disabled>
            <el-radio :label="item.value" v-for="(item, index) in headTypeList" :key="index">{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="单位名称：" prop="companyName">
          <!-- <el-input
            v-model="ruleForm.companyName"
            placeholder="请输入单位名称"
            style="width: 460px"
          ></el-input> -->
          <el-select :disabled="false" v-model="invoiceInfo" style="width: 460px" @change="changeInvoice">
            <el-option v-for="(item, index) in invoiceList" :key="index" :label="item.companyName" :value="JSON.stringify({ id: item.id, index })">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="默认发票类型：" prop="invoiceType" style="margin-bottom: 20px">
          <el-radio-group v-model="ruleForm.invoiceType" disabled>
            <el-radio :label="index" v-for="(item, index) in ['增值税普通发票', '增值税专用发票']" :key="index">{{ item }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="纳税人识别码：" prop="taxesNumber">
          <el-input v-model="ruleForm.taxesNumber" placeholder="请输入纳税人识别码" style="width: 460px" disabled></el-input>
        </el-form-item>
        <el-form-item label="注册地址：" prop="registAdress">
          <el-input v-model="ruleForm.registAdress" placeholder="请输入注册地址" style="width: 460px" disabled></el-input>
        </el-form-item>

        <el-form-item label="注册电话：" prop="registPhone">
          <el-input v-model="ruleForm.registPhone" placeholder="请输入注册电话" style="width: 460px" disabled></el-input>
        </el-form-item>
        <el-form-item label="开户银行：" prop="openingBank">
          <el-input v-model="ruleForm.openingBank" placeholder="请输入开户银行" style="width: 460px" disabled></el-input>
        </el-form-item>
        <el-form-item label="银行账户：" prop="bankAccount">
          <el-input v-model="ruleForm.bankAccount" placeholder="请输入银行账户" style="width: 460px" disabled></el-input>
        </el-form-item>
        <el-form-item label="接收方式：" prop="acceptType" style="margin-bottom: 20px" class="highlight">
          <el-radio-group v-model="ruleForm.acceptType" disabled>
            <el-radio :label="index" v-for="(item, index) in ['电子发票']" :key="index">{{ item }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <div style="color: #f89a00; margin: -15px 38px 20px">
          如需纸质发票，请联系客户经理
        </div>
        <!-- <el-checkbox v-model="isAgree" style="margin-left: 121px"
          >我已阅读并同意<span
            style="color: #F89A00; cursor: pointer"
            @click.prevent="dialogVisible = true"
            >《开票资质确认书》</span
          ></el-checkbox
        > -->
      </el-form>
      <div class="dialog_tip" v-show="!isShowQrCode">
        如有疑问请联系区域客服经理
        <!-- <img
          src="static/image/contactNumber.png"
          class="dialog_tipImg"
        /> -->
        <!-- <span style="color: #84c049">400-0258228</span> -->
      </div>
      <div class="dialog_tipBtn" @click="isShowQrCode = true" v-show="!isShowQrCode">
        <img src="static/image/qrCode.png" alt="" class="dialog_tipBtnImg" />
        <span>扫描二维码添加微信</span>
      </div>
      <span slot="footer" class="dialog-footer" v-show="!isShowQrCode">
        <el-button @click="resetForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-preventReClick>保 存</el-button>
      </span>
    </el-dialog>
    <!-- 上传签收单凭证弹窗 -->
    <el-dialog title="上传签收单凭证" :visible.sync="dialogVisible2" width="367px" :before-close="handleClose2" :destroy-on-close="true">
      <el-upload :action="baseURL + uploadUrl2" list-type="picture-card" :class="{ hideUploadLogo: perfectData, flexCenter: true }" :on-change="(file, fileList) => handleChange(file, fileList)" :before-upload="beforeUpload" :on-success="
          (response, file, fileList) => handleSuccess(response, file, fileList)
        " :on-remove="(file, fileList) => handleRemove(file, fileList)" :on-preview="(file, fileList) => handlePreview(file, fileList)" accept=".jpg,.jpeg,.png,.pdf" :limit="1">
        <div slot="tip" class="el-upload__tip">
          只能上传jpg/jpeg/png/pdf文件，且不超过500kb
        </div>
        <i class="el-icon-plus"></i>
      </el-upload>
      <el-dialog :visible.sync="visible">
        <img width="100%" :src="perfectData" alt="" />
      </el-dialog>

      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm2()">取 消</el-button>
        <el-button type="primary" @click="submitForm2()" v-preventReClick>确 认</el-button>
      </span>
    </el-dialog>
    <Dialog :dialogVisible="isShowQrCode" @closepop="isShowQrCode = false"></Dialog>

    <Dialog :isDefault="false" :dialogVisible="isNotReceived" @closepop="isNotReceived = false" width="388px" class="dialogBox">
      <div class="checkBox" slot="content">
        <img src="/static/image/receive.png" alt="" class="dialogBox_img" />
        <div class="dialogBox_text">请先确认收货再申请开具发票</div>
      </div>
    </Dialog>
    <Dialog :isDefault="false" :dialogVisible="isExceed" @closepop="resetExceed()" width="553px" class="dialogBox">
      <div class="checkBox" slot="content">
        <img src="/static/image/exceed.png" alt="" class="exceedBox_img" />
        <div class="exceedBox_text">
          {{
            mergeInvoice
              ? "合并订单开票不可超过十万，请重新选择"
              : "超10万订单根据税务规则自动拆分多张发票"
          }}
        </div>
        <div class="exceedBox_btnBox">
          <div class="exceedBox_btn" @click="resetExceed()" v-if="!mergeInvoice">
            取消
          </div>
          <div class="exceedBox_btn exceedBox_btnConfirm" :style="!mergeInvoice ? '' : 'width:377px'" @click="!mergeInvoice ? showDialog(0, peopleId) : resetExceed()">
            确认
          </div>
        </div>
      </div>
    </Dialog>

    <!-- 申请合同弹窗 -->
    <el-dialog title="申请合同" :visible.sync="visibleContract" width="767px" :close-on-click-modal="false">
      <el-form :model="contractForm" :rules="contractRules" ref="contractForm" label-width="121px" class="demo-ruleForm">
        <el-form-item label="签署方式" prop="signType">
          <el-select v-model="contractForm.signType" placeholder="请选择签署方式" style="width: 460px">
            <el-option
            v-for="item in signOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单位名称" prop="enterpriseName">
          <el-input v-model="contractForm.enterpriseName" placeholder="请输入单位名称" style="width: 460px" ></el-input>
        </el-form-item>
        <el-form-item label="经办人" prop="pickerName">
          <el-input v-model="contractForm.pickerName" placeholder="请输入经办人" style="width: 460px" ></el-input>
        </el-form-item>

        <el-form-item label="经办人手机号" prop="pickerMobile">
          <el-input v-model="contractForm.pickerMobile" placeholder="请输入经办人手机号" style="width: 460px" ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancelContract">取 消</el-button>
        <el-button type="primary" @click="handleOkContract" v-preventReClick>保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { doGet, baseURL, postAction } from "../../common/HttpHelper.js";
import { httpConfig } from "../../common/config.js";
import dialog from "../../common/dialog.vue";
import { MessageBox }from "element-ui";
export default {
  props: {
    title: String,
    required: true,
  },
  components: {
    Dialog: dialog,
  },
  data() {
    return {
      parentAccount: this.$cookies.get("userInfo")
        ? this.$cookies.get("userInfo").pcAccount
        : "",
      parentName: this.$cookies.get("userInfo")
        ? this.$cookies.get("userInfo").name
        : "",
      subAccountList: [],
      subPeopleId: JSON.parse(this.$cookies.get("peopleId")),
      baseURL,
      uploadUrl: httpConfig.proofPay.uploadProof, //上传文件接口
      editUrl: httpConfig.proofPay.updateProof, //修改凭证接口
      uploadUrl2: httpConfig.upload.url, //上传文件接口

      fileList: [], //上传文件列表
      navList: ["全部", "待付款", "待收货", "待退款", "待评价", "已评价"], //顶部导航栏列表
      chooseIndex: 0, //选中的nav的索引
      current: 1, //当前页数
      total: 0, //总条数
      limit: 8, //每页显示几条
      orderList: [], //订单列表
      token: localStorage.getItem("xfh_usertoken"),
      dialogVisible: false, //发票弹窗是否显示
      dialogVisible2: false, //上传签收单弹窗是否显示
      visibleContract: false, //申请合同弹窗是否显示
      contractForm:{
        signType:'',
        enterpriseName:'',
        pickerName:'',
        pickerMobile:'',
        orderId:'',
        ordersn:'',
      },
      signOptions:[
        {value:'',label:'请选择签署方式'},
        {value:1,label:'双方签署'},
        {value:2,label:'仅供应商签署'},
      ],
      contractRules: {
        signType:[{required: true, message: "请选择签署方式", trigger: "blur"}],
        enterpriseName:[{required: true, message: "请输入单位名称", trigger: "blur"}],
        pickerName:[{required: true, message: "请输入经办人", trigger: "blur"}],
        pickerMobile:[{required: true, message: "请输入经办人手机号", trigger: "blur"}],
      },
      headTypeList: [
        { label: "政府机关", value: 3 },
        { label: "事业单位", value: 2 },
        { label: "企业", value: 1 },
        // { label: "个人", value: 0 },
      ],
      //申请开票信息表单
      ruleForm: {
        headType: 3,
        companyName: "",
        invoiceType: 0,
        taxesNumber: "",
        registAdress: "",
        registPhone: "",
        openingBank: "",
        bankAccount: "",
      },
      //申请开票信息表单验证
      rules: {
        headType: [
          // { required: true, message: "请选择抬头类型", trigger: "change" },
        ],
        companyName: [
          // { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        invoiceType: [
          // { required: true, message: "请选择默认发票类型", trigger: "change" },
        ],
        taxesNumber: [
          // { required: true, message: "请输入纳税人识别码", trigger: "blur" },
        ],
        registAdress: [
          // { required: true, message: "请输入注册地址", trigger: "blur" },
        ],
        registPhone: [
          // { required: true, message: "请输入注册电话", trigger: "blur" },
          // { validator: phoneOrTelephone, trigger: "blur" },
        ],
        openingBank: [
          // { required: true, message: "请输入开户银行", trigger: "blur" },
        ],
        bankAccount: [
          // { required: true, message: "请输入银行账户", trigger: "blur" },
        ],
      },
      isAgree: false, //申请开票信息时是否同意规则
      orderId: {},
      peopleId: "",
      invoiceList: [], //发票信息列表
      invoiceInfo: "", //选中的发票信息
      isShowQrCode: false,

      chooseOrderId: "",
      choosePeopleId: "",

      visible: false,
      perfectData: undefined,
      isNotReceived: false, //是否展示先收货弹窗
      isExceed: false, //是否超额弹窗

      mergeInvoice: false, //是否合并开票
      totalPrice: 0, //开票合计金额
      totalInvoice: 0, //开票订单数
      orderIdList: [], //开票订单id列表
      isSelectAll: true, //是否全选
    };
  },
  mounted() {
    this.getList(1, false); //获取订单列表
    this.getInfo();
    this.getSubAccount();
  },
  methods: {
    /**
     * 时间格式化（补0）
     */
    add0(m) {
      return m < 10 ? "0" + m : m;
    },
    /**
     * 时间戳转换
     */
    getDate(time) {
      if (!time) return "";
      if (time == typeof string) {
        var reg = getRegExp("-", "g"); // 获取正则表达式，全局替换
        time = time.replace(reg, "/");
      }
      var date = new Date(time);
      var M = date.getMonth() + 1;
      var y = date.getFullYear();
      var d = date.getDate();
      var h = date.getHours();
      var mm = date.getMinutes();
      var s = date.getSeconds();
      if (M < 10) M = "0" + M;
      if (d < 10) d = "0" + d;
      return (
        y +
        "." +
        M +
        "." +
        d +
        " " +
        this.add0(h) +
        ":" +
        this.add0(mm) +
        ":" +
        this.add0(s)
      );
    },
    /**
     * 查询子账号
     */
    getSubAccount() {
      var that = this;
      doGet(
        httpConfig.subAccount.getSubAccountUrl,
        { parentAccount: this.parentAccount },
        function (res) {
          that.subAccountList = res.data;
        },
        function (res) {}
      );
    },
    /**
     * 切换查询账户
     */
    changeAccount(e) {
      this.getList(1, false);
    },
    /**
     * 选择发票
     */
    changeInvoice(e) {
      let data = JSON.parse(e);
      this.ruleForm = this.invoiceList[data.index];
    },
    /**
     * 上传凭证成功后的回调
     */
    uploadSuccess(res, file, fileList) {
      if (res.flag) {
        this.$message.success("上传成功");
        this.getList(1, false);
      } else {
        this.$message.error(res.message);
      }
    },
    /**
     * 获取订单列表
     */
    getList(val, mergeInvoice) {
      var OriMergeInvoice = this.mergeInvoice;
      if (this.mergeInvoice != mergeInvoice) {
        this.mergeInvoice = mergeInvoice;
      }
      var data = {
        current: val,
        limit: this.limit,
        subPeopleId: this.subPeopleId,
      };
      var dataMerge = {
        subPeopleId: this.subPeopleId,
        action: "merge",
      };
      switch (this.chooseIndex) {
        case 0:
          break;
        case 1:
          data["status"] = 0;
          break;
        case 2:
          data["status"] = 1;
          break;
        case 3:
          data["refundState"] = 0;
          break;
        case 4:
          data["isRate"] = 0;
          break;
        case 5:
          data["isRate"] = 1;
          break;
      }
      var that = this;
      doGet(
        httpConfig.myOrder.getListUrl,
        mergeInvoice ? dataMerge : data,
        function (res) {
          var OriOrderList = that.orderList;
          that.orderList = JSON.parse(JSON.stringify(res.rows));
          if (mergeInvoice && OriMergeInvoice) {
            that.totalInvoice = 0;
            that.totalPrice = 0;
            that.orderIdList = [];
            that.orderList.forEach((item, index) => {
              item.chooseStatus = 0;
              if (
                item.isInvoiced == 0 &&
                item.status == 3 &&
                OriOrderList[index].chooseStatus != 0
              ) {
                item.chooseStatus = 1;
                that.totalInvoice += 1;
                that.totalPrice += item.price;
                that.orderIdList.push({
                  orderId: item.id,
                  peopleId: item.peopleId,
                });
              } else if (item.isInvoiced == 1 || item.status != 3) {
                item.chooseStatus = 2;
              }
            });
          } else if (mergeInvoice && !OriMergeInvoice) {
            that.totalInvoice = 0;
            that.totalPrice = 0;
            that.orderIdList = [];
            that.orderList.forEach((item) => {
              item.chooseStatus = 2;
              if (item.isInvoiced == 0 && item.status == 3) {
                item.chooseStatus = 0;
                // that.totalInvoice += 1;
                // that.totalPrice += item.price;
                // that.orderIdList.push({
                //   orderId: item.id,
                //   peopleId: item.peopleId,
                // });
              }
            });
            that.isSelectAll = false;
          } else {
            that.total = res.total;
            that.current = val;
          }
        },
        function (res) {}
      );
    },
    /**
     * 切换分页
     */
    handleCurrentChange(val) {
      //返回顶部
      this.getList(val, false);
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    /**
     * 切换顶部导航栏
     */
    changeNav(index) {
      this.chooseIndex = index;
      this.getList(1, false);
    },
    /**
     * 订单详情
     */
    gotoDetails2(id, peopleId) {
      this.$router.push({ path: "/orderDetails", query: { id: id, peopleId } });
    },
    /**
     * 商品详情
     */
    gotoDetails(id) {
      if (id) {
        this.$router.push({ path: "/goodsInfo", query: { id: id } });
      } else {
        this.$message.error("商品不存在");
      }
    },
    /**
     * 立即评价
     */
    gotoRate(ordersn, createTime) {
      this.$router.push({ path: "/rateOrder", query: { ordersn, createTime } });
    },
    /**
     * 无效事件
     */
    nothing() {},
    /**
     * 确认收货
     */
    finishOrder(id, peopleId) {
      var that = this;
      // this.dialogVisible2 = true;

      // this.chooseOrderId = id;
      // this.choosePeopleId = peopleId;
      this.$confirm("确认收货？")
        .then((_) => {
          var data = {
            orderId: id,
          };
          doGet(
            httpConfig.myOrder.finishOrderUrl,
            data,
            function (res) {
              if (res.flag) {
                that.$message.success("收货成功");
                that.getList(1, that.mergeInvoice);
              } else {
                that.$message.warning(res.message);
              }
            },
            function (res) {}
          );
        })
        .catch((_) => {});
    },
    /**
     * 获取发票信息
     */
    getInfo() {
      var that = this;
      doGet(
        httpConfig.myInvoice.getInvoiceUrl,
        {},
        function (res) {
          that.invoiceList = res.data;
        },
        function (res) {}
      );
    },
    /**
     * 点击申请开票
     */
    showDialog(id, peopleId) {
      this.getInvoiceStatus().then((val) => {
        if (val == false) return;
        this.isExceed = false;
        // var date = new Date().getDate();
        // if (date > 25) {
        //   this.$message.warning("已过25号账期，请于下月1号开票");
        //   return;
        // }
        // this.$message.warning("电子发票暂时无法开具，请联系区域经理");
        // return;
        if (
          this.$cookies.get("userInfo") &&
          this.$cookies.get("userInfo").selfInvoicing == 0
        ) {
          this.$message.warning("请联系主账号申请开票！");
          return;
        }
        if (this.invoiceList.length == 0) {
          this.$message.warning("尚未添加发票信息，请先在-我的发票-中添加");
          return;
        }
        this.ruleForm = JSON.parse(JSON.stringify(this.invoiceList[0]));
        this.invoiceInfo = JSON.stringify({
          id: this.invoiceList[0].id,
          index: 0,
        });
        delete this.ruleForm.createTime;
        delete this.ruleForm.updateTime;
        if (id != 0) {
          this.orderId = { orderId: id, peopleId };
        }

        this.peopleId = peopleId;
        this.dialogVisible = true;
      });
    },
    /**
     * 关闭申请开票信息弹窗
     */
    handleClose(done) {
      var that = this;
      this.$confirm("确认关闭？")
        .then((_) => {
          if (that.isShowQrCode) {
            that.isShowQrCode = false;
          } else {
            that.resetForm("ruleForm");
            done();
          }
        })
        .catch((_) => {});
    },
    handleCancelContract() {
      this.$refs.contractForm.resetFields();
      this.visibleContract = false;
    },
    applyContract(record){
      this.visibleContract = true;
      this.contractForm.signType = '';
      this.contractForm.enterpriseName = record.enterpriseName;
      this.contractForm.pickerName = record.pickerName;
      this.contractForm.pickerMobile = record.pickerMobile;
      this.contractForm.orderId = record.id;
      this.contractForm.ordersn = record.ordersn;
    },
    handleOkContract() {
      this.$refs.contractForm.validate((valid) => {
        if(valid){
          // console.log('this.contractForm--',this.contractForm);
          const params = {
            signType: this.contractForm.signType,
            orgName: this.contractForm.enterpriseName,
            orderId: this.contractForm.orderId,
            ordersn: this.contractForm.ordersn,
            psnAccount: this.contractForm.pickerMobile,
            psnName: this.contractForm.pickerName,
          };
          postAction(
            httpConfig.myOrder.saveNameAndAccountUrl,
            params,
            (res) => {
              // console.log('res--',res);
              if(res.flag){
                this.visibleContract = false;
                this.contractForm={
                  signType:'',
                  enterpriseName:'',
                  pickerName:'',
                  pickerMobile:'',
                  orderId:'',
                  ordersn:'',
                }
                this.$message.success("申请成功");
                this.getList(1, false);
                MessageBox.alert("请在15分钟后到【合同管理】页面查看下载","申请成功");
              }else{
                this.$message.error(res.message);
              }
            },
            function (res) {}
          );
        }
      });
    },
    /**
     * 取消申请开票信息
     */
    resetForm(formName) {
      this.isAgree = false;
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    /**
     * 确认申请开票
     */
    submitForm(formName) {
      this.$confirm("发票一经开出，无法在系统中修改，请仔细核对开票信息", {
        confirmButtonClass: "confirm-btn",
      })
        .then((_) => {
          document.getElementsByClassName("confirm-btn")[0].disabled = true;
          var that = this;
          // if (this.isAgree) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
              });
              postAction(
                httpConfig.myInvoice.applyInvoiceUrl,
                {
                  peopleInvoiceId: JSON.parse(that.invoiceInfo).id,
                  // peopleId: that.peopleId,
                  orderInvoiceInfoDTOList:
                    that.mergeInvoice == true
                      ? that.orderIdList
                      : [that.orderId],
                  // peopleId: 70,
                  // orderId: 2,
                },
                function (res) {
                  loading.close();
                  document.getElementsByClassName(
                    "confirm-btn"
                  )[0].disabled = false;
                  if (res.flag) {
                    that.resetForm("ruleForm");
                    that.getList(1, false);
                    that.orderId = {};
                    that.$message({
                      message: res.message,
                      type: "success",
                    });
                  } else {
                    that.$message({
                      type: "error",
                      message: res.message,
                    });
                  }
                },
                function (res) {
                  document.getElementsByClassName(
                    "confirm-btn"
                  )[0].disabled = false;
                }
              );
            } else {
              document.getElementsByClassName(
                "confirm-btn"
              )[0].disabled = false;
              return false;
            }
          });
          // } else {
          //   that.$message.warning("请阅读并同意开票资质确认书");
          // }
        })
        .catch((_) => {});
    },
    /**
     * 关闭上传签收单凭证弹窗
     */
    handleClose2(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.resetForm2();
          done();
        })
        .catch((_) => {});
    },
    /**
     * 取消确认收货弹窗
     */
    resetForm2() {
      this.perfectData = undefined;
      this.dialogVisible2 = false;
      this.chooseOrderId = "";
      this.choosePeopleId = "";
    },
    /**
     * 确认收货
     */
    submitForm2() {
      var that = this;
      if (!this.perfectData) {
        this.$message.warning("请先上传签收单凭证");
        return;
      }
      this.$confirm("确认收货？")
        .then((_) => {
          var data = {
            orderId: that.chooseOrderId,
          };
          doGet(
            httpConfig.myOrder.finishOrderUrl,
            data,
            function (res) {
              if (res.flag) {
                that.$message.success("收货成功");
                that.getList(1, that.mergeInvoice);
                that.chooseOrderId = "";
                that.choosePeopleId = "";
                that.perfectData = undefined;
              } else {
                that.$message.warning(res.message);
              }
            },
            function (res) {}
          );
        })
        .catch((_) => {});
    },
    /**
     * 图片发生变化时
     */
    handleChange(file, fileList) {
      if (file.status == "ready") {
        this.perfectData = file.url;
      } else if (file.status == "error") {
        this.perfectData = undefined;
      }
    },
    /**
     * 上传文件前检查文件大小
     */
    beforeUpload(file) {
      const isJPG =
        file.type === "image/jpg" ||
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "application/pdf";
      const isLt500k = file.size / 1024 < 500;

      if (!isJPG) {
        this.$message.error("只能上传jpg/jpeg/png/pdf格式文件!");
      }
      if (!isLt500k) {
        this.$message.error("文件大小不能超过500kb!");
      }
      return isJPG && isLt500k;
    },
    /**
     * 上传成功
     */
    handleSuccess(response, file, fileList, item) {
      this.perfectData = response.data;
    },
    /**
     * 删除图片
     */
    handleRemove(file, fileList, item) {
      this.perfectData = undefined;
    },
    /**
     * 查看大图
     */
    handlePreview(file, fileList) {
      this.visible = true;
    },
    /**
     * 发票详情
     */
    gotoInvoiceDetails(id) {
      this.$router.push('/myInvoice');
      // this.$router.push({ path: "/invoiceDetails", query: { id: id } });
    },
    /**
     * 计算开票订单数和金额并且判断是否全选中
     */
    countInvoice() {
      this.totalInvoice = 0;
      this.totalPrice = 0;
      this.orderIdList = [];
      let isSelectAll = true;
      this.orderList.forEach((item) => {
        if (
          item.isInvoiced == 0 &&
          item.status == 3 &&
          item.chooseStatus == 1
        ) {
          this.totalInvoice += 1;
          this.totalPrice += item.price;
          this.orderIdList.push({ orderId: item.id, peopleId: item.peopleId });
        }
        if (item.chooseStatus == 0) {
          isSelectAll = false;
        }
      });
      this.isSelectAll = isSelectAll;
    },
    /**
     * 选中/取消选中开票订单
     */
    changeChoose(index, status) {
      this.orderList[index].chooseStatus = status == 0 ? 1 : 0;
      this.countInvoice();
    },
    /**
     * 全选/取消全选
     */
    selectAll() {
      let isSelectAll = this.isSelectAll;
      let that = this;
      this.isSelectAll = !isSelectAll;

      this.totalInvoice = 0;
      this.totalPrice = 0;
      this.orderIdList = [];

      this.orderList.forEach((item) => {
        item.chooseStatus = 2;
        if (item.isInvoiced == 0 && item.status == 3) {
          item.chooseStatus = isSelectAll ? 0 : 1;
          if (!isSelectAll) {
            that.totalInvoice += 1;
            that.totalPrice += item.price;
            that.orderIdList.push({
              orderId: item.id,
              peopleId: item.peopleId,
            });
          }
        }
      });
    },
    /**
     * 确认合并开票
     */
    submitMergeInvoice() {
      if (this.orderIdList.length == 0) {
        this.$message.warning("请选择开票订单！");
        return;
      }
      if (this.totalPrice > 100000) {
        this.isExceed = true;
        return;
      }
      this.showDialog(0, 0);
    },
    /**
     * 单笔订单超额
     */
    exceedShow(id, peopleId) {
      this.orderId = { orderId: id, peopleId };
      this.peopleId = peopleId;
      this.isExceed = true;
    },
    /**
     * 单笔订单超额取消
     */
    resetExceed() {
      this.peopleId = "";
      this.orderId = {};
      this.isExceed = false;
    },
    /**
     * 切换是否合并开票
     */
    changeMerge(isTop) {
      if (isTop) {
        this.getInvoiceStatus().then((val) => {
          if (val == false) return;
          this.getList(1, !this.mergeInvoice);
        });
      } else {
        this.getList(1, !this.mergeInvoice);
      }
    },
    /**
     * 获取开票状态
     */

    getInvoiceStatus() {
      return new Promise((resolve, reject) => {
        var that = this;
        doGet(
          httpConfig.myInvoice.getInvoiceStatusUrl,
          {},
          function (res) {
            if (res.flag) {
              if (res.data == 1) {
                resolve(true); //resolve()返回数据
              } else if (res.data == 0) {
                that.$message.warning(res.message);
                resolve(false); //resolve()返回数据
              }
            }
          },
          function (res) {}
        );
      });
    },
  },
};
</script>
<style scoped>
@import "../../../assets/css/personal/myOrder";
</style>



// WEBPACK FOOTER //
// src/components/page/personal/myOrder.vue